// extracted by mini-css-extract-plugin
export default {"SectionContainer":"VideoSection_SectionContainer__HcNKq","textP":"VideoSection_textP__q-p0t","text":"VideoSection_text__Y390C"};